"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchZones = exports.SearchBees = exports.SearchBeeData = exports.ListTrials = exports.GetWeeklyHeatingScheduleByZone = exports.GetWeeklyHeatingSchedule = exports.GetHotWaterSources = exports.GetHotWaterSchedules = exports.GetHotWaterInformation = exports.GetHeatingInformation = exports.GetFirmwareVersions = exports.GetControlPeripherals = exports.GetConfigProfileVersions = exports.GetBeeStatistics = exports.GetBeeModes = exports.GetAvailableConfigs = exports.FirmwareVersions = exports.UpgradeFirmware = exports.UpdateBee = exports.SendPeripheralCommand = exports.OverrideHotWater = exports.OverrideHeating = exports.EditEquinoxTrial = exports.DeleteTrial = exports.CreateWeeklyHeatingSchedule = exports.CreateTrial = exports.CreateHotWaterSchedules = exports.QueryOperator = exports.HotWaterSource = exports.HeatStatus = exports.BeeTag = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
var BeeTag;
(function (BeeTag) {
    BeeTag["Trustmark"] = "TRUSTMARK";
})(BeeTag = exports.BeeTag || (exports.BeeTag = {}));
var HeatStatus;
(function (HeatStatus) {
    HeatStatus["Off"] = "OFF";
    HeatStatus["On"] = "ON";
    HeatStatus["Unknown"] = "UNKNOWN";
})(HeatStatus = exports.HeatStatus || (exports.HeatStatus = {}));
var HotWaterSource;
(function (HotWaterSource) {
    HotWaterSource["CombiBoiler"] = "COMBI_BOILER";
    HotWaterSource["HeatPump"] = "HEAT_PUMP";
    HotWaterSource["ImmersionHeater"] = "IMMERSION_HEATER";
    HotWaterSource["Other"] = "OTHER";
    HotWaterSource["SystemBoiler"] = "SYSTEM_BOILER";
})(HotWaterSource = exports.HotWaterSource || (exports.HotWaterSource = {}));
var QueryOperator;
(function (QueryOperator) {
    QueryOperator["Between"] = "between";
    QueryOperator["Equals"] = "equals";
    QueryOperator["GreaterThan"] = "greaterThan";
    QueryOperator["GreaterThanOrEqual"] = "greaterThanOrEqual";
    QueryOperator["In"] = "in";
    QueryOperator["IsNull"] = "isNull";
    QueryOperator["LessThan"] = "lessThan";
    QueryOperator["LessThanOrEqual"] = "lessThanOrEqual";
    QueryOperator["Like"] = "like";
    QueryOperator["Not"] = "not";
})(QueryOperator = exports.QueryOperator || (exports.QueryOperator = {}));
exports.CreateHotWaterSchedules = (0, graphql_tag_1.default) `
    mutation createHotWaterSchedules($deviceId: ID, $hotWaterSchedules: WeeklyHotWaterScheduleInputs) {
  createHotWaterSchedules(
    deviceId: $deviceId
    hotWaterSchedules: $hotWaterSchedules
  ) {
    errorMessage
    success
  }
}
    `;
exports.CreateTrial = (0, graphql_tag_1.default) `
    mutation createTrial($createInput: CreateTrial) {
  createTrial(createInput: $createInput) {
    id
    meterableUnitId
    name
  }
}
    `;
exports.CreateWeeklyHeatingSchedule = (0, graphql_tag_1.default) `
    mutation createWeeklyHeatingSchedule($deviceId: ID, $heatingSchedule: WeeklyHeatingScheduleInputs) {
  createWeeklyHeatingSchedule(
    deviceId: $deviceId
    heatingSchedule: $heatingSchedule
  ) {
    errorMessage
    heatingSchedule {
      friday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      monday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      saturday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      sunday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      thursday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      tuesday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      wednesday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
    }
    success
  }
}
    `;
exports.DeleteTrial = (0, graphql_tag_1.default) `
    mutation deleteTrial($deleteInput: DeleteTrial) {
  deleteTrial(deleteInput: $deleteInput) {
    affected
  }
}
    `;
exports.EditEquinoxTrial = (0, graphql_tag_1.default) `
    mutation editEquinoxTrial($deviceId: String, $flag: Boolean) {
  editEquinoxTrial(deviceId: $deviceId, flag: $flag) {
    errorMessage
    success
  }
}
    `;
exports.OverrideHeating = (0, graphql_tag_1.default) `
    mutation overrideHeating($beeId: ID, $setpoint: Float, $zoneId: ID) {
  overrideHeating(beeId: $beeId, setpoint: $setpoint, zoneId: $zoneId) {
    error_message
    success
  }
}
    `;
exports.OverrideHotWater = (0, graphql_tag_1.default) `
    mutation overrideHotWater($deviceId: ID, $status: String) {
  overrideHotWater(deviceId: $deviceId, status: $status) {
    error_message
    success
  }
}
    `;
exports.SendPeripheralCommand = (0, graphql_tag_1.default) `
    mutation sendPeripheralCommand($deviceId: String, $deviceType: String, $requestedState: Float) {
  sendPeripheralCommand(
    deviceId: $deviceId
    deviceType: $deviceType
    requestedState: $requestedState
  ) {
    errorMessage
    success
  }
}
    `;
exports.UpdateBee = (0, graphql_tag_1.default) `
    mutation updateBee($bee: UpdateBee) {
  updateBee(bee: $bee) {
    arePeripheralsHealthy
    bee {
      arePeripheralsHealthy
      createdOn
      currentAppVersion
      currentFirmwareVersion
      deviceId
      firmwareUpdateRequested
      firmwareUpdateVersion
      firmwareVersion
      hardwareVersion
      inActiveTrialEvent
      isHealthy
      isHeatSourceOn
      physicalAddress {
        addressEnteredManually
        addressLine1
        city
        postcode
        udprn
      }
      plot
      project
      routerId
      stateLastUpdated
      status
      stickerImage
      tags
      trial {
        createdBy
        createdOn
        id
        meterableUnitId
        name
        updatedBy
        updatedOn
      }
      trialId
      updatedOn
      uprn
    }
    config {
      device_config {
        heating {
          temperature {
            lower
            upper
          }
        }
        hot_water_temperature {
          off
          on
        }
        location
        temperature {
          lower
          upper
        }
      }
      devices {
        ... on InternalDeviceType {
          fields {
            access
            address
            factor
            format
            length
            name
            unit
          }
          name
          protocol
        }
        ... on MBusDeviceType {
          name
          protocol
        }
        ... on MasterthermDeviceType {
          fields {
            compressor_off_time
            temperature
          }
          name
          protocol
        }
        ... on ModBusDeviceType {
          fields {
            access
            address
            factor
            format
            length
            name
            unit
          }
          name
          protocol
        }
        ... on RelayDeviceType {
          name
          protocol
        }
      }
      metadata {
        beeMode
        configProfileVersion
      }
      rules {
        inputs {
          address
          channel {
            address
            port
          }
          device_type
          hot_water_source_type
          metadata {
            circuit_type
            clamp_1_circuit_type
            clamp_2_circuit_type
            clamp_3_circuit_type
          }
          primary_zone_temperature_sensor
          zone_id
        }
        metadata {
          action_type
          category
          circuit_label
          clamp_1_circuit_label
          clamp_2_circuit_label
          clamp_3_circuit_label
          dip_switch_position
          heat_flow_meter_circuit
          heat_pump_heating_control
          heating_system
          install_location
          meter_amperage
          non_metered_circuits
          variant
        }
        name
      }
    }
    currentAppVersion
    hardwareVersion
    lastStatusUpdate
    latestAppVersion
    peripheralHealthChecks {
      data
      datapoint_checks {
        name
        status
        unit
        value
      }
      device_type
      reason
      status
      timestamp
      zone_id
    }
    status
    uptime
  }
}
    `;
exports.UpgradeFirmware = (0, graphql_tag_1.default) `
    mutation upgradeFirmware($upgradeFirmware: UpgradeFirmwareRequest) {
  upgradeFirmware(upgradeFirmware: $upgradeFirmware) {
    url
  }
}
    `;
exports.FirmwareVersions = (0, graphql_tag_1.default) `
    query firmwareVersions($deviceId: String, $hardwareVersion: String) {
  firmwareVersions(deviceId: $deviceId, hardwareVersion: $hardwareVersion) {
    firmwareVersions
  }
}
    `;
exports.GetAvailableConfigs = (0, graphql_tag_1.default) `
    query getAvailableConfigs {
  getAvailableConfigs {
    availableConfigs {
      displayName
      originalFileName
    }
  }
}
    `;
exports.GetBeeModes = (0, graphql_tag_1.default) `
    query getBeeModes {
  getBeeModes {
    beeModes
  }
}
    `;
exports.GetBeeStatistics = (0, graphql_tag_1.default) `
    query getBeeStatistics($query: QueryBee) {
  getBeeStatistics(query: $query) {
    numberOfDevicesOffline
    numberOfDevicesOnline
    totalBees
    totalHealthcheckErrors
  }
}
    `;
exports.GetConfigProfileVersions = (0, graphql_tag_1.default) `
    query getConfigProfileVersions {
  getConfigProfileVersions {
    configProfileVersions
  }
}
    `;
exports.GetControlPeripherals = (0, graphql_tag_1.default) `
    query getControlPeripherals($deviceId: ID) {
  getControlPeripherals(deviceId: $deviceId) {
    peripherals {
      deviceCategory
      deviceType
      hasPermission
      state
    }
  }
}
    `;
exports.GetFirmwareVersions = (0, graphql_tag_1.default) `
    query getFirmwareVersions {
  getFirmwareVersions {
    firmwareVersions
  }
}
    `;
exports.GetHeatingInformation = (0, graphql_tag_1.default) `
    query getHeatingInformation($beeId: ID, $zoneId: ID) {
  getHeatingInformation(beeId: $beeId, zoneId: $zoneId) {
    heating_state
    lower_bounds
    setpoint
    temperature
    upper_bounds
  }
}
    `;
exports.GetHotWaterInformation = (0, graphql_tag_1.default) `
    query getHotWaterInformation($deviceId: ID) {
  getHotWaterInformation(deviceId: $deviceId) {
    device_hot_water_active
    hot_water_active
    schedule_hot_water_active
    set_at {
      by
      day
      time
    }
  }
}
    `;
exports.GetHotWaterSchedules = (0, graphql_tag_1.default) `
    query getHotWaterSchedules($deviceId: ID, $getNextSchedule: Boolean) {
  getHotWaterSchedules(deviceId: $deviceId, getNextSchedule: $getNextSchedule) {
    friday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    monday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    saturday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    sunday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    thursday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    tuesday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    wednesday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
  }
}
    `;
exports.GetHotWaterSources = (0, graphql_tag_1.default) `
    query getHotWaterSources {
  getHotWaterSources {
    hotWaterSources
  }
}
    `;
exports.GetWeeklyHeatingSchedule = (0, graphql_tag_1.default) `
    query getWeeklyHeatingSchedule($deviceId: ID) {
  getWeeklyHeatingSchedule(deviceId: $deviceId) {
    friday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    monday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    saturday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    sunday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    thursday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    tuesday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    wednesday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
  }
}
    `;
exports.GetWeeklyHeatingScheduleByZone = (0, graphql_tag_1.default) `
    query getWeeklyHeatingScheduleByZone($deviceId: ID, $zoneId: ID) {
  getWeeklyHeatingScheduleByZone(deviceId: $deviceId, zoneId: $zoneId) {
    friday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    monday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    saturday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    sunday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    thursday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    tuesday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    wednesday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
  }
}
    `;
exports.ListTrials = (0, graphql_tag_1.default) `
    query listTrials {
  listTrials {
    itemCount
    items {
      createdBy
      createdOn
      id
      meterableUnitId
      name
      updatedBy
      updatedOn
    }
  }
}
    `;
exports.SearchBeeData = (0, graphql_tag_1.default) `
    query searchBeeData($query: QueryBee) {
  searchBeeData(query: $query) {
    arePeripheralsHealthy
    bee {
      arePeripheralsHealthy
      createdOn
      currentAppVersion
      currentFirmwareVersion
      deviceId
      firmwareUpdateRequested
      firmwareUpdateVersion
      firmwareVersion
      hardwareVersion
      inActiveTrialEvent
      isHealthy
      isHeatSourceOn
      physicalAddress {
        addressEnteredManually
        addressLine1
        city
        postcode
        udprn
      }
      plot
      project
      routerId
      stateLastUpdated
      status
      stickerImage
      tags
      trial {
        createdBy
        createdOn
        id
        meterableUnitId
        name
        updatedBy
        updatedOn
      }
      trialId
      updatedOn
      uprn
    }
    config {
      device_config {
        heating {
          temperature {
            lower
            upper
          }
        }
        hot_water_temperature {
          off
          on
        }
        location
        temperature {
          lower
          upper
        }
      }
      devices {
        ... on InternalDeviceType {
          fields {
            access
            address
            factor
            format
            length
            name
            unit
          }
          name
          protocol
        }
        ... on MBusDeviceType {
          name
          protocol
        }
        ... on MasterthermDeviceType {
          fields {
            compressor_off_time
            temperature
          }
          name
          protocol
        }
        ... on ModBusDeviceType {
          fields {
            access
            address
            factor
            format
            length
            name
            unit
          }
          name
          protocol
        }
        ... on RelayDeviceType {
          name
          protocol
        }
      }
      metadata {
        beeMode
        configProfileVersion
      }
      rules {
        inputs {
          address
          channel {
            address
            port
          }
          device_type
          hot_water_source_type
          metadata {
            circuit_type
            clamp_1_circuit_type
            clamp_2_circuit_type
            clamp_3_circuit_type
          }
          primary_zone_temperature_sensor
          zone_id
        }
        metadata {
          action_type
          category
          circuit_label
          clamp_1_circuit_label
          clamp_2_circuit_label
          clamp_3_circuit_label
          dip_switch_position
          heat_flow_meter_circuit
          heat_pump_heating_control
          heating_system
          install_location
          meter_amperage
          non_metered_circuits
          variant
        }
        name
      }
    }
    currentAppVersion
    hardwareVersion
    lastStatusUpdate
    latestAppVersion
    peripheralHealthChecks {
      data
      datapoint_checks {
        name
        status
        unit
        value
      }
      device_type
      reason
      status
      timestamp
      zone_id
    }
    status
    uptime
  }
}
    `;
exports.SearchBees = (0, graphql_tag_1.default) `
    query searchBees($query: QueryBee) {
  searchBees(query: $query) {
    itemCount
    items {
      arePeripheralsHealthy
      createdOn
      currentAppVersion
      currentFirmwareVersion
      deviceId
      firmwareUpdateRequested
      firmwareUpdateVersion
      firmwareVersion
      hardwareVersion
      inActiveTrialEvent
      isHealthy
      isHeatSourceOn
      physicalAddress {
        addressEnteredManually
        addressLine1
        city
        postcode
        udprn
      }
      plot
      project
      routerId
      stateLastUpdated
      status
      stickerImage
      tags
      trial {
        createdBy
        createdOn
        id
        meterableUnitId
        name
        updatedBy
        updatedOn
      }
      trialId
      updatedOn
      uprn
    }
  }
}
    `;
exports.SearchZones = (0, graphql_tag_1.default) `
    query searchZones($deviceId: String) {
  searchZones(deviceId: $deviceId) {
    itemCount
    items {
      description
      heating_state
      lower_bounds
      setpoint
      temperature
      upper_bounds
      zone_id
    }
  }
}
    `;
